'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('../index');

var _core = require('../middlewares/core');

var core = _interopRequireWildcard(_core);

var _hubapi = require('../middlewares/hubapi');

var hubapi = _interopRequireWildcard(_hubapi);

var _debug = require('../middlewares/debug');

var debug = _interopRequireWildcard(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = (0, _index.createStack)(core.services, hubapi.defaults, debug.allowTimeoutOverride, core.jsonBody, core.httpsOnly, hubapi.hubapi, core.withQuery, debug.rewriteUrl, core.reportOptionsError, hubapi.retryOnError, core.validateStatus, core.jsonResponse);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.219/js/stacks/noAuthWithCredentialsHubapi.js
// module id = 455
// module chunks = 177